<div class="fund-filters">
  <div edsGrid>
    <div class="container container--wide" edsPadding edsPaddingTop="lg">
      <div edsRow>
        <!-- Title -->
        <div edsCol [columnNumbers]="{ s: '4', m: '3', l: '7' }">
          <div
            edsFlexbox
            [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
            [alignItems]="(isHandheld$ | async) ? 'flex-start' : 'center'"
            edsPadding
            edsPaddingTop="sm"
          >
            <eds-title
              size="h2"
              [level]="1"
              [isLight]="true"
              [title]="preSelectedValue?.label"
              edsPadding
              edsPaddingRight="sm"
            ></eds-title>

            <div
              edsFlexbox
              alignItems="center"
              [edsSpacing]="(isHandheld$ | async) ? 'sm' : 'none'"
            >
              <!-- Spinner -->
              <div class="fund-filters__loader" *ngIf="!isLoaded">
                <ngx-spinner
                  name="fundLoadingSpinner"
                  bdColor="rgba(0,0,0,0)"
                  size="small"
                  color="#fff"
                  type="line-scale-party"
                  [fullScreen]="false"
                >
                </ngx-spinner>
              </div>

              <!-- Showing X of Y -->
              <p
                *ngIf="isLoaded"
                edsPadding
                edsPaddingRight="sm"
                edsSpacing="none"
              >
                {{ "products.ppss-listing-displaying" | translate }}
                <b>{{ productNumberofFilteredData }}</b>
                {{ "products.ppss-listing-of" | translate }}
                <b>{{ productTotalNumberOfData }}</b>
                {{ "products.ppss-listing-items" | translate }}
              </p>

              <!-- Reset -->
              <div
                *ngIf="
                  isSearchText ||
                  selectedFilterLabels.length !== 0 ||
                  state?.morningStarFilter.selected.length
                "
                edsFlexbox
              >
                <span edsPadding edsPaddingRight="sm">|</span>
                <eds-link-item
                  theme="dark"
                  [title]="'products.ppss-filter-reset' | translate"
                  [hasIcon]="true"
                  type="reset"
                  class="text-white"
                  (click)="resetFilters($event)"
                  customIconClass="analytics-reset"
                  eventId="form_filter"
                  [analyticsNoEvent]="true"
                ></eds-link-item>
              </div>
            </div>
          </div>
        </div>

        <!-- Product Type Filter -->
        <div edsCol [columnNumbers]="{ s: '4', m: '3', l: 'auto' }">
          <ng-container *ngIf="productTypeOptions?.length > 1">
            <eds-dropdown
              class="print-hidden"
              edsSpacing="md"
              ariaLabel="Dropdown"
              [id]="'product-type-select'"
              name="product-type-select"
              [label]="'products.product-type-select' | translate"
              [items]="productTypeOptions"
              [preselectedValue]="preSelectedValue"
              (dropdownChange)="selectProduct($event)"
            ></eds-dropdown>
          </ng-container>
        </div>
      </div>

      <!-- Show actual filter(s), when state available, else load Filter(s) Skeleton Loader -->
      <div *ngIf="state?.lastAction; else skeletonProductsBanner">
        <div edsRow>
          <!-- Primary Filter(s) -->
          <ng-container *ngFor="let filterOptions of state.primaryFilters">
            <eds-dropdown
              class="print-hidden"
              *ngIf="filterOptions.options.length > 0"
              [style.whiteSpace]="'nowrap'"
              [isActiveMenuLeft]="(isHandheld$ | async) === false"
              edsSpacing="md"
              edsPadding
              edsCol
              [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
              ariaLabel="Dropdown"
              [id]="filterOptions.type.key"
              [name]="filterOptions.type.key"
              [label]="
                'products.ppss-filter-' + filterOptions.label | translate
              "
              [titleText]="'products.ppss-filter-select' | translate"
              [selectedText]="'products.ppss-filter-selected' | translate"
              [multi]="true"
              [required]="false"
              [items]="filterOptions.options"
              [preselectedValue]="filterOptions.preSelectedValues"
              (dropdownChange)="
                updateFilter('primary', filterOptions.label, $event)
              "
              eventType="form_filter"
              #filtersDropDowns
              [linkUrl]="chipRemoveUrl"
            ></eds-dropdown>
          </ng-container>

          <!-- Search Box -->
          <eds-search
            class="print-hidden"
            *ngIf="state.searchKeyword"
            fieldId="FilterByKeyword"
            edsCol
            [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
            edsSpacing="md"
            edsPadding
            edsPaddingBottom="md"
            [label]="state.searchKeyword.type.key"
            [placeholder]="
              'products.portfolio-holdings-search-box-placeholder' | translate
            "
            (searchTerm)="searchByKeyword($event)"
            [value]="
              state.searchKeyword?.selected
                ? state.searchKeyword?.selected[0]
                : ''
            "
            #filterSearch
          ></eds-search>
        </div>

        <!-- Additional Filter(s) -->
        <div edsRow>
          <div edsCol>
            <eds-accordion
              class="print-hidden"
              theme="basic"
              *ngIf="state?.additionalFilters?.length > 0"
            >
              <eds-accordion-item
                [noPadding]="true"
                theme="dark"
                edsSpacing="md"
                [title]="'products.additional-filter' | translate"
              >
                <div edsRow>
                  <ng-container
                    *ngFor="
                      let filterOptions of state.additionalFilters;
                      let i = index
                    "
                  >
                    <div
                      *ngIf="filterOptions.options.length > 0"
                      edsSpacing="md"
                      edsCol
                      [columnNumbers]="{ s: '4', m: '2' }"
                    >
                      <eds-dropdown
                        [isActiveMenuLeft]="
                          (isHandheld$ | async) === true &&
                          (isMobile$ | async) === false
                        "
                        edsPadding
                        ariaLabel="Dropdown"
                        [id]="filterOptions.type.key"
                        [name]="filterOptions.type.key"
                        [label]="
                          'products.ppss-filter-' + filterOptions.label
                            | translate
                        "
                        [titleText]="'products.ppss-filter-select' | translate"
                        [selectedText]="
                          'products.ppss-filter-selected' | translate
                        "
                        [multi]="true"
                        [required]="false"
                        [items]="filterOptions.options"
                        [preselectedValue]="filterOptions.preSelectedValues"
                        (dropdownChange)="
                          updateFilter(
                            'additional',
                            filterOptions.label,
                            $event
                          )
                        "
                        eventType="form_filter"
                        #filtersDropDowns
                      ></eds-dropdown>
                    </div>
                  </ng-container>
                </div>
              </eds-accordion-item>
            </eds-accordion>
          </div>
        </div>
      </div>

      <!-- Filter Chips -->
      <div edsRow alignItems="top"></div>
    </div>
  </div>
</div>

<!-- Filter(s) Skeleton Loader -->
<ng-template #skeletonProductsBanner>
  <div edsRow>
    <ng-container
      *ngFor="let item of [].constructor(filterCount); let i = index"
    >
      <!-- Primary Filter Skeleton Loader -->
      <ngx-skeleton-loader
        animation="pulse"
        [theme]="{
          'background-color': '#e8e8e8',
          'border-radius': '0',
          height: 'var(--space-xxl)'
        }"
      ></ngx-skeleton-loader>
      <eds-dropdown
        [loading]="true"
        edsSpacing="md"
        edsPadding
        edsCol
        [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
      ></eds-dropdown>
    </ng-container>

    <div
      edsCol
      [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
      edsPadding
      edsPaddingBottom="md"
      edsSpacing="md"
    >
      <!-- Search Box Skeleton Loader -->
      <ngx-skeleton-loader
        animation="pulse"
        [theme]="{
          'background-color': '#e8e8e8',
          'border-radius': '0',
          height: 'var(--space-xxl)'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>

  <!-- Additional Filter Skeleton Loader -->
  <div edsRow>
    <div edsCol>
      <eds-accordion theme="dark" *ngIf="additionalFiltersCount > 0">
        <eds-accordion-item
          [noPadding]="true"
          theme="dark"
          [title]="'products.additional-filter' | translate"
        >
        </eds-accordion-item>
      </eds-accordion>
    </div>
  </div>
</ng-template>
